import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const QuickSearcMobileList = ({ result, selectedItem, isMobile, query }) => {
    let maxLength = 0;
    // Positions from BO
    let positions = [];
    // Quicksearchresult 4 sections layout
    let listingNumbers = Array.from(Array(4), (x, i) => i + 1);
    // Epmty sections required for positioning
    let missingNumbers;

    return (
        <ul className="quick-search-result">
            {result &&
                result.resultGroups.map((group, index1) => {
                    positions.push(group.resultGroupPosition);
                    missingNumbers = listingNumbers.filter(
                        value => -1 === positions.indexOf(value)
                    );

                    let numberToSlice = isMobile
                        ? 3
                        : 5;
                    let position = positions[index1];

                    return (
                        <Fragment key={`${group.name}-${index1}`}>
                            <li
                                className={`quick-search-result__item ${'item-order-' + position
                                    } small-12 large-4`}
                            >
                                <div className="quick-search-result__group-header">
                                    <span>{group.name}&nbsp;</span>
                                    {group.count > 0 && (
                                        <span className="quick-search-result__counter">
                                            ({group.count})
                                        </span>
                                    )}
                                </div>
                                <div className="quick-search-result__group">
                                    <ul>
                                        {group.results.length > 0 &&
                                            group.results
                                                .slice(0, numberToSlice)
                                                .map((item, index2) => {
                                                    maxLength += 1;
                                                    let highlightedMatch = item?.name?.replace(
                                                        new RegExp(
                                                            decodeURIComponent(
                                                                query
                                                            ),
                                                            'gi'
                                                        ),
                                                        match =>
                                                            `<mark>${match}</mark>`
                                                    );

                                                    return (
                                                        <Fragment
                                                            key={`${item.name}-${index2}`}
                                                        >
                                                            <li
                                                                className={`quick-search-result__item ${selectedItem ===
                                                                        maxLength -
                                                                        1
                                                                        ? 'quick-search-result__item--selected'
                                                                        : ''
                                                                    }`}
                                                            >
                                                                <a
                                                                    className="quick-search-result__link"
                                                                    href={
                                                                        item.url
                                                                    }
                                                                >
                                                                    {highlightedMatch ? (
                                                                        <span
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: highlightedMatch,
                                                                            }}
                                                                        ></span>
                                                                    ) : (
                                                                        <span>
                                                                            {
                                                                                item.name
                                                                            }
                                                                        </span>
                                                                    )}
                                                                </a>
                                                            </li>
                                                        </Fragment>
                                                    );
                                                })}
                                    </ul>
                                </div>
                            </li>
                        </Fragment>
                    );
                })}
            {missingNumbers.length > 0 &&
                missingNumbers.map((num, i) => {
                    return (
                        <li
                            key={`${num}-${i}`}
                            className={`quick-search-result__item ${'item-order-' + num
                                }`}
                        />
                    );
                })}
        </ul>
    );
};

export default QuickSearcMobileList;